import classNames from 'classnames';
import { parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { FormattedDate } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/prizes/ticket.module.scss';

const propTypes = {
    className: PropTypes.string,
    nameClassName: PropTypes.string,
    prize: AppPropTypes.prize,
};

const defaultProps = {
    className: null,
    nameClassName: null,
    prize: null,
};

function Ticket({ className, nameClassName, prize }) {
    const { prize: prizeObject, ticket } = prize || {};
    const { image, name } = prizeObject || {};
    const { url: imageUrl = null } = image || {};
    const { date = null } = ticket || {};

    const themeClassName = useThemeClassName(styles);
    const dateObj = useMemo(() => (date !== null ? parseISO(date) : null), [date]);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.imageContainer}>
                {imageUrl !== null ? (
                    <img className={styles.image} src={imageUrl} alt={name} />
                ) : null}
            </div>
            <div
                className={classNames([styles.name, { [nameClassName]: nameClassName !== null }])}
                dangerouslySetInnerHTML={{ __html: name }}
            />
            {dateObj !== null ? (
                <div className={styles.date}>
                    Date:{' '}
                    <FormattedDate value={dateObj} day="numeric" month="long" weekday="long" />
                </div>
            ) : null}
        </div>
    );
}

Ticket.propTypes = propTypes;
Ticket.defaultProps = defaultProps;

export default Ticket;
